<template>
    <section id="comic">
        <h2>Read The Comic</h2>
        <p>Check back the first day of every month for a brand spanking new chapter!</p>
        <img src="@/assets/images/comic_page.png" >
        <p class="underline">The Origins of LambDoge</p>
        <a class="button btn-solid btn-disabled">
            Chapter 1
        </a>
        <p class="sub-text">Coming soon</p>
    </section>
</template>

<script>
export default {

}
</script>

<style>
#comic p {
    margin: 10px auto;
    max-width: 420px;
}
#comic img {
    width: 100%;
    max-width: 350px;
    margin: 10px auto;
}
</style>